import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { mapProps, compose } from 'recompose'
import { connect } from 'react-redux'
import { Flex } from 'reflexbox'
import { List, ListSubHeader, ListCheckbox } from 'react-toolbox/lib/list'
import { Card } from 'react-toolbox/lib/card'
import Subheading from 'components/typography/subheading/index'
import { PROJECT_ROLES, GLOBAL_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'

import {
  onSelectFilter,
  onUnselectFilter
} from './actions'
import {
  filtersSelector
} from './selectors'
import {
  chartCategoryEnum
} from './constants'
import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    filters: filtersSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleFilter: (checked, value) => {
      if (checked) {
        dispatch(onSelectFilter(value))
      } else {
        dispatch(onUnselectFilter(value))
      }
    }
  }
}

const ChartFilter = (props) => {
  const {
    filters,
    onToggleFilter
  } = props

  const RestrictedCheckbox = compose(
    mapProps((props) => ({
      ...props,
      roles: [GLOBAL_ROLES.ADMIN_ACCESS]
    })),
    showOnAnyRoles,
  )(ListCheckbox)

  const renderCheckbox = (chart) => {
    return (
      <React.Fragment>
        {chart.restricted ?
          <RestrictedCheckbox
            key={chart.value}
            caption={chart.label}
            checked={filters.includes(chart.value)}
            onChange={(check) => onToggleFilter(check, chart.value)}
            theme={styles}
          /> :
          <ListCheckbox
            key={chart.value}
            caption={chart.label}
            checked={filters.includes(chart.value)}
            onChange={(check) => onToggleFilter(check, chart.value)}
            theme={styles}
          />}
      </React.Fragment>
    )
  }

  return (
    <Card styleName='chartFilterContainer'>
      <Flex
        wrap
        column
      >
        <Subheading>Reports</Subheading>
        <List
          selectable
          theme={styles}
        >
          {Object.values(chartCategoryEnum).map((category, index) => (
            <React.Fragment key={index}>
              <ListSubHeader
                theme={styles}
                caption={category.value}
              />
              {category.charts.map((chart, index) => (
                <React.Fragment key={index}> 
                  {renderCheckbox(chart)}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </List>
      </Flex>
    </Card>
  )
}

const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ChartFilter)
